import React from "react";
import PillButtonLink from "../buttons/PillButtonLink";

const ArticleFooter = ({ message, buttonText, buttonUrl }) => {
  return (
    <>
      {message && <p className="top-msg mt-8">{message}</p>}
      <div className="center-button mt-7 mb-8">
        <PillButtonLink
          buttonText={buttonText}
          targetUrl={buttonUrl}
          buttonStyle="filled"
        />
      </div>
    </>
  );
};

export default ArticleFooter;
